import React from 'react';
import logoImg from '../logo.png';
import leftArrow from '../assets/images/left-arw.svg';
// import tw from '../assets/images/tw.svg';
// import fb from '../assets/images/fb.svg';
// import yt from '../assets/images/yt.svg';
// import insta from '../assets/images/insta.svg';
// import linkedin from '../assets/images/linkedin.svg';

import { ReactComponent as tw } from '../assets/images/tw.svg';
import { ReactComponent as fb } from '../assets/images/fb.svg';
import { ReactComponent as yt } from '../assets/images/yt.svg';
import { ReactComponent as insta } from '../assets/images/insta.svg';
import { ReactComponent as linkedin } from '../assets/images/linkedin.svg';

const socialLinks = {
  Twitter: 'https://x.com/AAbbamonte',
  Linkedin: 'https://www.linkedin.com/in/antoinette-abbamonte-a2ba4719/',
  Facebook: 'https://www.facebook.com/antoinetteabbamonte/',
  Instagram: 'https://www.instagram.com/antoinetteabbamonte/',
};

const socialIcons = {
  Twitter: tw,
  Facebook: fb,
  YouTube: yt,
  Instagram: insta,
  Linkedin: linkedin,
};

const Footer = () => {
  return (
    <>
      <footer className="bg-[#421B03] w-full sm:pb-6 relative px-5  z-10 pt-10 sm:pt-[80px] px-5 sm:px-6 md:px-12">
        <style>
          {`
          .scl-btn i svg {
            user-select: none;
            flex-shrink: 0;
            display: inline-block;
            transition: all 0.4s ease;
          }
          .scl-btn:hover i svg path {
            stroke: #f2ba35;
          }

          .scl-btn:hover i svg rect {
            stroke: #f2ba35;
          }

          .linkedin:hover i svg path {
          fill: #f2ba35;
          }
        `}
        </style>
        <div className="relative max-w-[1260px] mx-auto   rounded-0">
          {/* Decorative vertical lines */}
          <div className="absolute inset-0 z-0 flex justify-between none sm:flex rounded-0">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="w-[1px] bg-white h-full opacity-[0.06]" />
            ))}
          </div>
          {/* <div className="absolute top-0 left-0 z-[1] pointer-events-none	">
          <img src={ftrGradient} alt="" />
        </div> */}
          <img
            src={logoImg}
            alt="MSP"
            className=" w-[106px] h-[106px] mx-auto mb-2 sm:mb-8 z-[1]"
          />
          <div className=" rounded-[30px] p-[20px] lg:p-[50px] pb-[14px] lg:pb-[14px] text-center lg:text-left bg-[#4E2B14]  border border-solid border-[#836A5A] relative z-[1]">
            <div className=" flex gap-[50px] lg:gap-[150px] flex-col lg:flex-row">
              <div className="lg:w-1/2 w-full">
                {/* <p className="text-[#FBC153] text-bold text-[cinzel] uppercase text-xl	 md:text-xl	mb-2">
            Support the movement
          </p> */}
                <h2 className="lg:text-[30px] text-white text-[18px] lg:leading-[113%] leading-[30px] font-bold font-cinzel uppercase tracking-[-2px] mb-4">
                  Changing the landscape of cinema through bold, authentic Deaf
                  representation.
                </h2>
                <p className="text-white lg:text-[20px] lg:leading-[120%] text-[16px] font-ubuntu mb-5 lg:mb-16 mt-2 lg:mt-6">
                  Invest is authentic, Deaf-led storytelling that challenges the
                  status quo and shapes the future of inclusive cinema.
                </p>
                <button className="group relative bg-gradient-to-r from-yellow-400 to-yellow-500 lg:ps-[30px] lg:pe-[30px] px-[20px] py-[10px] lg:py-[0] flex items-center justify-start text-start sm:text-center sm:justify-center mx-auto lg:leading-[88px] border gap-[10px] border-solid border-white lg:min-w-[550px] lg:text-[20px] text-[12px] font-ubuntu font-bold rounded-full text-white overflow-hidden hover:bg-custom-gradient-btn hover:text-[17px]">
                  <span className="transition-all duration-400 ease-ease-custom transform sm:group-hover:-translate-x-[30px]">
                    Join us in rewriting the narrative in Hollywood
                  </span>
                  <div className="transition-all duration-400 ease-ease-custom transform sm:group-hover:translate-x-almost-full">
                    <div className="w-[44px] h-[44px] sm:group-hover:w-[74px] sm:group-hover:h-[74px] flex items-center justify-center rounded-full transition-all duration-400 ease-ease-custom group-hover:bg-[rgba(207,207,207,0.15)] group-hover:rotate-[-45deg]">
                      <img
                        src={leftArrow}
                        alt="Join us in transforming Hollywood"
                        className="transition-transform duration-400 ease-ease-custom"
                      />
                    </div>
                  </div>
                </button>
              </div>

              <div className="lg:w-1/2 w-full flex flex-col flex-wrap gap-3 lg:gap-[30px]">
                {['Twitter', 'Facebook', 'Linkedin', 'Instagram'].map(
                  (platform, index) => {
                    const IconComponent = socialIcons[platform];

                    return (
                      <a
                        key={index}
                        href={socialLinks[platform]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`scl-btn group flex items-center justify-between cursor-pointer rounded-full border border-solid border-[#54321B] transition-all duration-400 ease-custom hover:border-[#836A5A] no-underline ${
                          platform === 'Linkedin' ? 'linkedin' : ''
                        }`}
                      >
                        <div className="text-[20px] text-white font-ubuntu font-light bg-[#54321B] h-full rounded-full transition flex-1 px-6 leading-[60px] lg:leading-[50px] rounded-e-none flex items-center gap-4 transition-all duration-400 ease-custom group-hover:rounded-full">
                          <i className="flex items-center justify-center w-[20px] h-[20px] transition-all duration-400 ease-custom group-hover:w-[36px] group-hover:h-[36px] ">
                            <IconComponent className="w-full h-full object-contain transition-all duration-400 ease-custom" />
                          </i>
                          {platform.toUpperCase()}
                        </div>
                        <div className="bg-[#54321B] py-3 rounded-full w-[60px] h-[60px] flex items-center justify-center rounded-s-none transition-all duration-400 ease-custom group-hover:rounded-full">
                          <img
                            src={leftArrow}
                            alt={platform.toUpperCase()}
                            className="transition-all duration-400 ease-custom group-hover:rotate-[-45deg]"
                          />
                        </div>
                      </a>
                    );
                  }
                )}
              </div>
            </div>
            <div className="mt-6 lg:mt-[50px]">
              <h3 className="text-[16px] text-white font-bold	font-cinzel w-full text-center">
                Contact Us
              </h3>
              <div className="flex w-full">
                <a
                  href="mailto:antoinetteabbamonte@gmail.com"
                  className="text-white text-base py-2 w-full font-ubuntu text-xs md:text-sm  text-center"
                >
                  antoinetteabbamonte@gmail.com
                </a>
              </div>
            </div>
          </div>

          <div className="pt-5 pb-4 lg:pb-0	mt-5 flex items-center justify-between relative z-1 border-t-[1px] border-solid border-[#fff]">
            <p className="italic text-white font-ubuntu text-[16px] lg:text-[20px] m-0">
              @Created By
            </p>
            <p className="italic text-white font-ubuntu text-[16px] lg:text-[20px] m-0">
              All right reserved
            </p>
          </div>
          {/* CONTACT SECTION */}
          {/* <div id="contact" className="mt-[10px] relative z-[1]">
          <div className="rounded-[30px] p-4 sm:px-10 sm:pt-6 sm:pb-9  border border-solid border-[#836A5A] relative">
            <h3 className="text-2xl	font-cinzel mb-3">Contact Us</h3>
            <div className="flex">
              <a
                href="mailto:info@mermaidsignatureproduction.com"
                className="bg-[#54321B] px-[22px] text-base py-4 w-full font-ubuntu rounded-full text-xs md:text-sm"
              >
                info@mermaidsignatureproduction.com
              </a>
            </div>
          </div>
         
        </div> */}
        </div>
      </footer>
    </>
  );
};

export default Footer;
